import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowUp, Square } from 'iconoir-react';
import { useAgentBlocksTextContext } from '../../text/agent-blocks-text-context';
import { IconAction } from '../shared/IconAction';
/**
 * Round solid button at the end of the composer: charcoal as soon as there
 * is something to send (the recipe dims it until then), and "Arrêter" while
 * an answer is being written.
 */
export function ComposerSendButton({ canSend, isAnswering, onSend, onStop }) {
    const text = useAgentBlocksTextContext();
    return (_jsx(IconAction, { label: isAnswering ? text.composer.stop : text.composer.send, icon: isAnswering ? _jsx(Square, { fill: "currentColor" }) : _jsx(ArrowUp, {}), onClick: isAnswering ? onStop : onSend, disabled: isAnswering ? !onStop : !canSend, variant: "solid", borderRadius: "full", 
        // A filled square reads heavier than the arrow: one notch smaller.
        _icon: { boxSize: isAnswering ? '3' : '4' }, color: "agent.contrast", _hover: { bg: 'agent.solidHover', color: 'agent.contrast' } }));
}
